export class RequestCheckpoint {
    constructor(loadedFiles, requestTime) {
        this.loadedFiles = loadedFiles,
        this.requestTime = requestTime;
    }
}